<template>
  <section class="cta">
      <div class="cta__content container">
        <h1 class="cta__text --fade-in-up" data-vertical-ivp-class="--animate">
          An Experienced Leader in a Growing, Multi-Billion $$ Market
        </h1>
        <div class="cta__buttons --fade-in-up" data-vertical-ivp-class="--animate">
          <a href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view"
          target="_blank">
            <button class="button">
              Invest Now
            </button>
          </a>
          <a href="https://www.sec.gov/Archives/edgar/data/1826135/000152013822000450/mhhc_1sa.htm"
          target="_blank">
            <button class="button">
              READ OFFERING CIRCULAR
            </button>
          </a>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'CTA',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/cta.scss";
</style>
